import { render, staticRenderFns } from "./ModelosAtividade.vue?vue&type=template&id=156bf767&"
import script from "./ModelosAtividade.vue?vue&type=script&lang=js&"
export * from "./ModelosAtividade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports